/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-15 16:45:12
 * @LastEditTime: 2026-04-16 20:23:02
 * @LastEditors: ranli
 */
// 定义比赛状态枚举
// 状态1-Scheduled(即将开始), 2-Completed(完成), 3-Live(进行中) 已取消 4-Aborted(已取消)
export const MatchStatus = {
  NOT_STARTED: 1,
  COMPLETED: 2,
  LIVE: 3,
  ABORTED: 4,
}
/**
 * 比赛状态映射
 */
export const MatchStatusMap = {
  [MatchStatus.NOT_STARTED]: 'Scheduled',
  [MatchStatus.COMPLETED]: 'Completed',
  [MatchStatus.LIVE]: 'Live',
  [MatchStatus.ABORTED]: 'Aborted',
}
// //
// 运营状态
// 1 未开始报名—— 比赛不开放
// 2 报名开始—— 可以创建队伍进行报名，可以随时修改队伍
// 3 报名截止—— 不能报名，且队伍锁定队伍，不能修改
// 4 Live —— 比赛进行中，整体房间内部状态会变调
// 5 结算中 —— 比赛已经结束，正在进行结算
// 6 已结束 —— 结算完成后的赛事，结束掉
// 7 已取消 ——因为一些异常原因取消掉了，需要给已经报名的用户退款
export const OperationStatus = {
  NOT_STARTED_OPERATION: 1,
  STARTED_OPERATION: 2,
  ENDED_OPERATION: 3,
  LIVE_OPERATION: 4,
  SETTLED_OPERATION: 5,
  COMPLETED_OPERATION: 6,
  CANCELLED_OPERATION: 7,
}
/**
 * 运营状态映射
 */
export const OperationStatusMap = {
  [OperationStatus.NOT_STARTED_OPERATION]: 'Not Started Operation',
  [OperationStatus.STARTED_OPERATION]: 'Started Operation',
  [OperationStatus.ENDED_OPERATION]: 'Ended Operation',
  [OperationStatus.LIVE_OPERATION]: 'Live Operation',
  [OperationStatus.SETTLED_OPERATION]: 'Settled Operation',
  [OperationStatus.COMPLETED_OPERATION]: 'Completed Operation',
  [OperationStatus.CANCELLED_OPERATION]: 'Cancelled Operation',
}

/**
 * 球员角色映射表 - 统一处理各种格式的角色名称
 * 支持后端返回的小写格式、组件内部使用的大写格式、以及全名格式
 */
export const RoleMapping = {
  // 小写格式（后端返回）
  wk: 'WK',
  bat: 'BAT',
  all: 'AR',
  bowl: 'BOWL',
  // 大写格式（组件内部使用）
  WK: 'WK',
  BAT: 'BAT',
  AR: 'AR',
  BOWL: 'BOWL',
  // 全名格式
  Wicketkeeper: 'WK',
  'Wicket-Keeper': 'WK',
  Batter: 'BAT',
  'All-Rounder': 'AR',
  Bowler: 'BOWL',
}

/**
 * 角色显示顺序 - 用于列表排序
 */
export const RoleOrder = ['wk', 'bat', 'all', 'bowl']

/**
 * 根据原始角色获取标准角色代码
 * @param {string} role - 原始角色名称
 * @returns {string} 标准角色代码（WK, BAT, AR, BOWL）
 */
export function getStandardRole(role) {
  if (!role) return 'BAT'
  return RoleMapping[role] || RoleMapping[role.toLowerCase()] || 'BAT'
}

/**
 * 角色位置限制配置
 */
export const RoleLimits = {
  WK: { min: 1, max: 8, label: 'WK' },
  BAT: { min: 1, max: 8, label: 'BAT' },
  AR: { min: 1, max: 8, label: 'AR' },
  BOWL: { min: 1, max: 8, label: 'BOWL' },
}
